const restConfigs = [
  {
    key: "restBackgroundOverlay",
    input: {
      type: "slider"
    },
    label: "Background Overlay",
    value: 0
  },
  {
    key: "restMedia",
    input: {
      type: "assetMulti"
    },
    label: "Background Media",
    value: []
  },
  {
    key: "restCta",
    input: {
      type: "text"
    },
    label: "Rest Call To Action",
    value: {
      en: ""
    }
  },
  {
    key: "restTitle",
    input: {
      type: "text"
    },
    label: "Rest Title",
    value: {
      en: ""
    }
  },
  {
    key: "restCompanyLogo",
    input: {
      type: "asset"
    },
    label: "Company Logo Image",
    value: ""
  },
  {
    key: "restDevelopmentLogo",
    input: {
      type: "asset"
    },
    label: "Development Logo Image",
    value: ""
  }
];

const categoryConfigs = [
  {
    key: "categoryBackground",
    input: {
      type: "asset"
    },
    label: "Background Image",
    value: ""
  }
];

const liveConfigs = [
  {
    key: "liveHereSelectionBackground",
    input: {
      type: "asset"
    },
    label: "Selection Background",
    value: ""
  },
  {
    key: "liveHereBackground",
    input: {
      type: "asset"
    },
    label: "Masterplan Image",
    value: ""
  },
  {
    key: "liveHereBackgroundFallback",
    input: {
      type: "asset"
    },
    label: "Masterplan Image Fallback",
    value: ""
  },
  {
    key: "liveHereMasterplanAccessCode",
    input: {
      type: "text"
    },
    label: "Masterplan Access PIN",
    value: ""
  },
  {
    key: "liveHereSidebarMinimap",
    input: {
      type: "asset"
    },
    label: "Sidebar Minimap Image",
    value: ""
  },
  {
    key: "liveHereHeading",
    input: {
      type: "text"
    },
    label: "Sidebar Heading",
    value: {
      en: ""
    }
  },
  {
    key: "liveHereDescription",
    input: {
      type: "rich"
    },
    label: "Sidebar Description",
    value: {
      en: ""
    }
  },
  {
    key: "liveHereMasterplanTags",
    input: {
      type: "tags"
    },
    label: "Masterplan Tags",
    value: []
  }
];

const packagesConfigs = [
  {
    key: "liveHerePackagesSidebarHeading",
    input: {
      type: "text"
    },
    label: "Packages Sidebar Heading",
    value: {
      en: ""
    }
  },
  {
    key: "liveHerePackagesSidebarDesc",
    input: {
      type: "rich"
    },
    label: "Packages Sidebar Description",
    value: {
      en: ""
    }
  }
];

const favouritesConfigs = [
  {
    key: "liveHereFavouritesBackground",
    input: {
      type: "asset"
    },
    label: "Favourites Background Image",
    value: ""
  },
  {
    key: "liveHereFavouritesSidebarHeading",
    input: {
      type: "text"
    },
    label: "Favourites Sidebar Heading",
    value: {
      en: ""
    }
  },
  {
    key: "liveHereFavouritesSidebarDesc",
    input: {
      type: "rich"
    },
    label: "Favourites Sidebar Description",
    value: {
      en: ""
    }
  }
];

const generalConfigs = [
  {
    key: "generalSidebarLogo",
    input: {
      type: "asset"
    },
    label: "Sidebar Logo",
    value: ""
  },
  {
    key: "generalSidebarBrandLogo",
    input: {
      type: "asset"
    },
    label: "Sidebar Brand Logo",
    value: ""
  },
  {
    key: "generalSidebarHeaderColour",
    input: {
      type: "colour"
    },
    label: "Sidebar Header Colour",
    value: "#bbd976"
  },
  {
    key: "generalSidebarDescriptionColour",
    input: {
      type: "colour"
    },
    label: "Sidebar Description Colour",
    value: "#ffffff"
  }
];

export const configs = [
  ...restConfigs,
  ...categoryConfigs,
  ...liveConfigs,
  ...packagesConfigs,
  ...favouritesConfigs,
  ...generalConfigs
];
